<!-- <div [formGroup]="alFormGroup">
    <input type="text"
    
           [class]="alClass"
           class="w-100"
           [class.is-invalid]="(alFormControl.invalid && alFormControl.dirty) || (alFormControl.invalid && IsFormSubmitted)"
           [formControlName]="alFormControlName"
           [placeholder]="alPlaceHolder">
    <div class="invalid-feedback" *ngIf="(alFormControl.invalid && IsFormSubmitted) || alFormControl.dirty">

        <span>{{alName}}</span>
        <span *ngIf="alFormControl.hasError('pattern')"> is invalid.</span>
        <span *ngIf="alFormControl.hasError('pattern') && (alName == 'Primary Phone' || alName=='Secondary Phone')"> Do not include 1 or +1 before phone number.</span>
        <span *ngIf="alFormControl.hasError('required')"> is required.</span>
        <span *ngIf="alFormControl.hasError('maxlength')"> is too long.</span>



    </div>
</div> -->
@if(FormControl && FormControlName){
<input
    [class]="Class"
    [class.is-invalid]="(FormControl.invalid && FormControl.touched) || (FormControl.invalid && formSubmitted)"
    [formControl]="FormControl"
       [type]="FormControlType"
/>

<div class="invalid-feedback" *ngIf="FormControl.invalid">
    @if(ValidationMessages){ @for(item of ValidationMessages; track item){
    <div *ngIf="FormControl.hasError(item.validationName)">{{ item.validationMessage }}</div>
    } }
</div>
}

